import { useState } from "react";
import { Link } from "react-router-dom";

const COASidebarComponent = ({ data }) => {
  const [openParent, setOpenParent] = useState(null);
  const [openGroup, setOpenGroup] = useState(null);
  const [openSubGroup, setOpenSubGroup] = useState(null);

  return (
    <div
      className="border rounded p-2 bg-light"
      style={{ width: "auto", maxHeight: "600px", overflowY: "auto" }}
    >
      <h5 className="my-2">Chart of Accounts</h5>

      <ul className="list-group list-group-flush">
        {data.map((account) => (
          <li
            key={account.id}
            className="list-group-item border-0 p-1"
          >
            {/* Parent */}
            <div
              className="d-flex justify-content-between align-items-center fw-bold"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpenParent(
                  openParent === account.id ? null : account.id
                );
                setOpenGroup(null);
                setOpenSubGroup(null);
              }}
            >
              <span title="Parent Group">📁 {account.name}</span>
              <span>{openParent === account.id ? "−" : "+"}</span>
            </div>

            {/* Group Types */}
            {openParent === account.id && (
              <ul className="list-group list-group-flush ms-3 mt-2">
                {account.group_types?.length > 0 ? (
                  account.group_types.map((group) => (
                    <li
                      key={group.id}
                      className="list-group-item border-0 p-1"
                    >
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenGroup(
                            openGroup === group.id ? null : group.id
                          );
                          setOpenSubGroup(null);
                        }}
                      >
                        <span title="Group Type">📂 {group.name}</span>
                        <span>{openGroup === group.id ? "−" : "+"}</span>
                      </div>

                      {/* Sub Group Types */}
                      {openGroup === group.id && (
                        <ul className="list-group list-group-flush ms-3 mt-2">
                          {group.sub_group_type?.length > 0 ? (
                            group.sub_group_type.map((sub) => (
                              <li
                                key={sub.id}
                                className="list-group-item border-0 p-1"
                              >
                                <div
                                  className="d-flex justify-content-between align-items-center"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setOpenSubGroup(
                                      openSubGroup === sub.id
                                        ? null
                                        : sub.id
                                    )
                                  }
                                >
                                  <span title="Sub Group Type">📄 {sub.name}</span>
                                  <span>
                                    {openSubGroup === sub.id
                                      ? "−"
                                      : "+"}
                                  </span>
                                </div>

                                {/* Ledger Groups */}
                                {openSubGroup === sub.id && (
                                  <ul className="list-group list-group-flush ms-3 mt-2">
                                    {sub.ledger_group?.length > 0 ? (
                                      sub.ledger_group.map((ledger) => (
                                        <Link to={`/flexichain/chart-of-account?ledger_master_id=${btoa(ledger.id)}`}>
                                          <li
                                            key={ledger.id}
                                            className="list-group-item border-0 p-1"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            // onClick={() => {
                                            //   console.log(
                                            //     "Ledger Selected:",
                                            //     ledger
                                            //   );
                                            //   // Your ledger click logic here
                                            // }}
                                          >
                                            <span title="Ledger Group">
                                              💰 {ledger.name}
                                            </span>
                                          </li>
                                        </Link>
                                      ))
                                    ) : (
                                      <li className="list-group-item border-0 p-1 fst-italic text-muted">
                                        No ledger group found.
                                      </li>
                                    )}
                                  </ul>
                                )}
                              </li>
                            ))
                          ) : (
                            <li className="list-group-item border-0 p-1 fst-italic text-muted">
                              No subgroup type found.
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  ))
                ) : (
                  <li className="list-group-item border-0 p-1 fst-italic text-muted">
                    No group type found.
                  </li>
                )}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default COASidebarComponent;